"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.error = exports.debug = void 0;

var index_1 = require("./index");

var _ref = (0, index_1.createLog)('feature'),
    debug = _ref.debug,
    error = _ref.error,
    warn = _ref.warn;

exports.debug = debug;
exports.error = error;
exports.warn = warn;